// extracted by mini-css-extract-plugin
export var container = "_ej-0";
export var icon = "_ej-1";
export var text = "_ej-2";